import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import DataTable from "../../../features/DataTable";
import { getAdmin } from "../../../../services/apiAdmin";
import styles from "../../../layout/admin/Main.module.scss";
import SearchForm from "./SearchForm";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Button from "../../../ui/Button";
import CSVDownloader from "../../../ui/CSVDownloader";

const tableMeata = [
  { key: "login_id", label: "管理者ID" },
  { key: "name", label: "名前" },
  { key: "university_id", label: "大学ID" },
];
const AdminUser = () => {
  // 検索条件{"name":"名前"}
  const [searchCondition, setSearchCondition] = useState({});
  // 一覧データ
  const [tableData, setTableData] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const tableResetRef = useRef();

  useEffect(() => {
    const setTableDataFunc = (d) => {
      return {
        key: d.login_id,
        login_id: <Link to={"./register/update/" + d.id}>{d.login_id}</Link>,
        name: d.name,
        university_id: d.university_id,
      };
    };
    const setTableSortDataFunc = (d) => {
      return {
        key: d.login_id,
        login_id: d.login_id,
        name: d.name,
        university_id: d.university_id,
      };
    };
    const mapCsvFunc = (d) => {
      const col = {};
      col["管理者ID"] = d.login_id;
      col["名前"] = d.name;
      col["大学ID"] = d.university_id;
      return col;
    };

    (async function () {
      const data = await getAdmin(searchCondition);
      // テーブルデータセット
      setTableData(data.map(setTableDataFunc));
      setTableSortData(data.map(setTableSortDataFunc));
      // CSVデータセット
      setCsvData(data.map(mapCsvFunc));
      //ページネーション・ソートをリセット
      tableResetRef.current?.click();
    })();
  }, [searchCondition]);
  return (
    <div className={styles.main}>
      <ScreenTitle>管理ユーザー管理</ScreenTitle>
      <SubScreenTitle>管理ユーザー新規登録</SubScreenTitle>
      <div className={styles.buttonbox__left}>
        <Link to={"/admin/admin/register/new/0"}>
          <Button styleType="new">新規登録する</Button>
        </Link>
      </div>
      <SubScreenTitle>管理ユーザー検索</SubScreenTitle>
      <SearchForm setSearchCondition={setSearchCondition} />
      <DataTable
        tableData={tableData}
        tableMeata={tableMeata}
        tableSortData={tableSortData}
        tableResetRef={tableResetRef}
      />
      <CSVDownloader
        data={csvData}
        filenameprefix="管理ユーザー一覧"
        buttonname="ダウンロード"
      />
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
    </div>
  );
};
export default AdminUser;
